import React, { useEffect, useState } from "react";
import Equation from "./Equation";
import { CommonDialog } from "../../common/CommonDialog";

export default class EquationDialog extends React.Component
{    
    editor = React.createRef();
    
    constructor(props)
    {
        super(props);            
    }
    componentDidUpdate(prevProps,prevState)
    {
        console.log("EquationDialog:cdu");
        if(prevProps.mathData!=this.props.mathData)
        {
            if(this.editor.current)
                this.editor.current.setMathML(this.props.mathData.eqn);
        }
    }
    _onCancel=()=>{
        this.props.onCancel();
    }
    _onOK=()=>{
        this.editor.current.getPNG((imageData)=>{
            this.editor.current.getMathML((eqnData,align)=>{
                this.props.onOK(imageData,eqnData,align);
            });
        });
    }
    render()
    {
        return(
            <>
            <CommonDialog header="Equation" visible={this.props.visible} onOK={this._onOK} onCancel={this._onCancel}>
                <div className="p-2" style={{maxWidth:'600px'}}>
                    <Equation ref={this.editor} mathData={this.props.mathData}></Equation>
                </div>
            </CommonDialog>
            </>
        );
    }
}